import FieldDate from "../../../generic/datetime/date/date"
import FieldConfig from "../../../proto/field-config"
import Event from "../../../../model2/event/event"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import GanttManager from "../../../../gd-modules/gantt-chart/manager/manager"
import {ViewType} from "../../../../gd/const/views/view-type"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldEventStartDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-start'
        this.label              = 'Start date'

        // this.renderComponents.tableCell     = FieldProto_TableCellReadOnly
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Event):boolean {
        return model.acl.canChangeStartDate
    }


    // Custom Methods

    tableCellOnValueChange = async (item: ItemModelV2, value:Moment|null, manager:TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const endStartDiff = moment(item.event.endDate).diff(moment(item.event.startDate), 'days')
                const newStartDate = moment(value)
                const newEndDate = moment(value).add(endStartDiff,'days')

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.event.updateStartDate(value, {keepCalendarDuration:true})
                item.event.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }
    }
}
